"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushNotificationsContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const i18n_1 = require("@completeanatomy/i18n");
const storage_1 = require("@completeanatomy/storage");
const ui_1 = require("@completeanatomy/ui");
const user_1 = require("@completeanatomy/user");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const PrimaryButton_1 = require("../../atoms/PrimaryButton/PrimaryButton");
const SecondaryButton_1 = require("../../atoms/SecondaryButton/SecondaryButton");
const Subtitle_1 = require("../../atoms/Subtitle/Subtitle");
const Title_1 = require("../../atoms/Title/Title");
const withDelayedAppearance_1 = require("../../hocs/withDelayedAppearance");
const Route_1 = require("../../router/Route");
const mediaQueries_1 = require("../../styles/mediaQueries");
const PageContent_1 = require("../../templates/PageContent/PageContent");
function PushNotificationsContent() {
    const { t } = (0, i18n_1.useTranslation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const bridge = (0, bridge_1.useBridge)();
    const storage = (0, storage_1.useStorageService)();
    const currentUser = (0, user_1.useUser)();
    const onContinue = (0, react_1.useCallback)((declined) => __awaiter(this, void 0, void 0, function* () {
        storage === null || storage === void 0 ? void 0 : storage.put('pushNotificationsDeclined', declined);
        if (currentUser) {
            if ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.identifier) && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.kind) === '-') {
                return navigate(`${Route_1.Route.Base}/${Route_1.Route.ProfileSurvey}/${Route_1.Route.MissingProfile}`);
            }
            navigate(`/hub`);
        }
        else {
            navigate(`${Route_1.Route.Base}/${Route_1.Route.ProfileSurvey}`);
        }
    }), // eslint-disable-next-line react-hooks/exhaustive-deps -- storage deps
    [currentUser, navigate]);
    const onDeclineNotifications = () => {
        onContinue('true');
    };
    const onAcceptNotifications = () => __awaiter(this, void 0, void 0, function* () {
        try {
            yield (bridge === null || bridge === void 0 ? void 0 : bridge.requestPushNotificationsPermissions());
        }
        catch (error) {
            console.error('Error setting push notifications:', error);
        }
        onContinue('false');
    });
    const image = () => {
        return (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Push_Notifications, "data-e2e": 'PushNotificationsContent_Icon' });
    };
    return ((0, jsx_runtime_1.jsx)(PageContent_1.PageContent, { Image: image, content: (0, jsx_runtime_1.jsxs)(RightContainer, { children: [(0, jsx_runtime_1.jsx)(StyledTitle, { children: t(i18n_1.Strings.userOnboarding.pushNotifications.title) }), (0, jsx_runtime_1.jsx)(StyledSubtitle, { children: t(i18n_1.Strings.userOnboarding.pushNotifications.subtitle) }), (0, jsx_runtime_1.jsxs)(ButtonsContainer, { children: [(0, jsx_runtime_1.jsx)(StyledSecondaryButton, { onClick: onDeclineNotifications, children: t(i18n_1.Strings.userOnboarding.pushNotifications.decline) }), (0, jsx_runtime_1.jsx)(PrimaryButton_1.PrimaryButton, { onClick: onAcceptNotifications, children: t(i18n_1.Strings.userOnboarding.pushNotifications.accept) })] })] }), "data-e2e": 'PushNotificationsContent_PageContent' }));
}
exports.PushNotificationsContent = PushNotificationsContent;
exports.default = (0, storage_1.withStorageProvider)((0, bridge_1.withBridgeProvider)((0, withDelayedAppearance_1.withDelayedAppearance)(PushNotificationsContent, 300, 200)));
const RightContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;

  ${mediaQueries_1.device.desktop `
    max-height: 625px;
  
    align-items: flex-start;
  `};
`;
const StyledTitle = (0, styled_components_1.default)(Title_1.Title) `
  margin-bottom: 16px;
  padding: 0 15px;

  ${mediaQueries_1.device.desktop `
    height: 164px;

    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    
    text-align: left;
    margin-bottom: 40px;
  `}
`;
const StyledSubtitle = (0, styled_components_1.default)(Subtitle_1.Subtitle) `
  padding: 0 25px;

  ${mediaQueries_1.device.desktop `
    height: 72px;
    padding-right: 15px;
    text-align: left;
  `}
`;
const StyledSecondaryButton = (0, styled_components_1.default)(SecondaryButton_1.SecondaryButton) `
  margin-bottom: 16px;

  ${mediaQueries_1.device.mobileLandscape `
    margin-bottom: 0;
    margin-right: 16px;
  `};

  ${mediaQueries_1.device.desktop `
    margin-bottom: 16px;
    margin-right: 0;
  `};
`;
const ButtonsContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  margin-top: auto;
  width: 100%;
  align-items: center;
  justify-content: center;

  ${mediaQueries_1.device.mobileLandscape `
    flex-direction: row;
  `};

  ${mediaQueries_1.device.desktop `
    flex-direction: column;
  `};
`;
